<template>
<div style="text-align: center;margin-top: 100px">
  <p>
    <i class="el-icon-success" style="color: green"></i>感谢您宝贵的反馈和建议，您的需求是我们改进的动力，{{sec}}秒后自动跳转到项目列表.....<img src="image/running2.gif">
  </p>

</div>
</template>

<script>
export default {
  name: "Thanks",
  data(){
    return{
      sec:3
    }
  },
  // mounted:{
  //
  //   this.timer = setInterval(() => {
  //     this.btnText = `${this.oneMinutes}s`;
  //     this.oneMinutes--;
  //     if (this.oneMinutes <= 0) {
  //       this.btnText = '';
  //       this.showTime = false;
  //       this.oneMinutes = 60;
  //       // clearInterval(that.tiemr);
  //     }
  //   }, 1000)
  // }]
  mounted() {
      this.timer = setInterval(() => {
        this.sec--;
        if (this.sec=== 0) {
        this.$router.push("/sampleUpload")
          // clearInterval(that.tiemr);
        }
      }, 1000)
    // ]
  }

}
</script>

<style scoped>

</style>
